export default __webpack_public_path__ + "static/media/bg-image-mobile.b7745f9d.png";